import { ChangeDetectionStrategy, Component } from '@angular/core';

import { OfflineGuidelinesTableComponent } from './offline-guidelines-table/offline-guidelines-table.component';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-offline-dashboard',
  templateUrl: './offline-dashboard.component.html',
  styleUrls: ['./offline-dashboard.component.scss'],
  imports: [OfflineGuidelinesTableComponent],
  providers: [],
})
export class OfflineDashboardComponent {}
